import { render, staticRenderFns } from "./MakingPurchase.vue?vue&type=template&id=531a14cb&scoped=true"
import script from "./MakingPurchase.vue?vue&type=script&lang=ts"
export * from "./MakingPurchase.vue?vue&type=script&lang=ts"
import style0 from "./MakingPurchase.vue?vue&type=style&index=0&id=531a14cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531a14cb",
  null
  
)

export default component.exports